import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Login from "./login"
import Staff from "./containers/staff"
import Shop from "./containers/shop";
import Track from "./containers/track";
import View from "./containers/track/view";
import ViewShop from "./containers/shop/shopMap";
import Report from "./containers/report";
import Region from "./containers/admin/region";
import Role from "./containers/admin/role";
import ViewLocation from "./containers/location_view";

class Routes extends Component {
  constructor(props) {
    super(props);
}
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  render() {
    // console.log('this.props',this.props)
    const  userdata = this.props
    return (
      <div >
        <Switch>
          {/* <Route exact path="/" component={Staff} /> */}
          <Route exact path="/" render={(props) => <Staff userdata={userdata} />} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/staff" render={(props) => <Staff userdata={userdata} />} />
          <Route exact path="/shop" render={(props) => <Shop userdata={userdata} />} />
          {/* <Route exact path="/shop" component={Shop} /> */}
          <Route exact path="/track" component={Track} />
          <Route exact path="/track/view" component={View} />
          <Route exact path="/report" component={Report} />
          <Route exact path="/shop/shopMap" component={ViewShop} />
          <Route exact path="/admin/region" component={Region} />
          <Route exact path="/admin/role" component={Role} />
          <Route exact path="/location_view" component={ViewLocation} />
          
        </Switch>
      </div>
    )
  }

}

export default Routes;
